import Home from "pages";
import { useEffect } from "react";
import { getPageData } from "../utils/getSeoMenu";
import {
  viewFrontPage,
} from "@/components/common/Nosto";
import { useRouter } from "next/compat/router";
import { useSelector } from "react-redux";

export async function getStaticProps() {
  return {
    props: {
      homepage: await getPageData('/') || null,
    },
  };
}

const RegisterPage = ({ homepage }) => {
  const router = useRouter();
  const loggedIn = useSelector((state) => state.loginUser);

  //to handle api calls when logged in using /login
  useEffect(() => {
    if (router.asPath === "/register") {
      if (loggedIn.userLoggedIn === undefined) {
        viewFrontPage();
      }
      else {
        router.push("/account");
      }
    }
  }, [loggedIn])


  return (
    <>
      <Home accountOpen={true} tabToOpen={"home"} content={homepage} />
    </>
  );
};

export default RegisterPage;
